<script lang="ts" setup>
import Top from '~/components/Top/Top.vue'
import type { IProps } from '@/domains/career/components/career-teamWithHeader/career-teamWithHeader.types'
import MsFoundation from '~/domains/esg/key-activities/components/MsFoundation/MsFoundation.vue'
import Multiuczynek from '~/domains/esg/key-activities/components/Multiuczynek/Multiuczynek.vue'
import FairPlay from '~/domains/esg/key-activities/components/FairPlay/FairPlay.vue'

const { t, locale } = useI18n()

defineProps<IProps>()

useHead({
  title: t('pageTitles.keyActivities.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.keyActivities.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.keyActivities.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.keyActivities.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.keyActivities.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.keyActivities.canonical.pl'),
    },
  ],
})

</script>

<template>
  <div>
    <Top
      :header="$t('keyActivities.top.header')"
      :subheader="$t('keyActivities.top.subheader')"
      :text="$t('keyActivities.top.text')"
    />

    <MsFoundation />

    <Multiuczynek />

    <FairPlay />

    <UiSection
      id="press-office"
      color="gray"
      class="press-office"
    >
      <UiHeader
        :position="'center'"
        :header="$t('keyActivities.pressOffice.header')"
        :subheader="$t('keyActivities.pressOffice.subheader')"
        :class="'press-office__header'"
      />

      <UiButton
        :to="$t('keyActivities.pressOffice.button.link')"
        :variant="'primary'"
        :target="'_blank'"
        class="press-office__button"
      >
        {{ $t('keyActivities.pressOffice.button.text') }}
      </UiButton>
    </UiSection>
  </div>
</template>

<style lang="scss" scoped>
:deep(.top) {
  min-height: 55.4rem;
  margin-bottom: 1.6rem;
}

:deep(.top__header) {
  overflow-wrap: break-word;
}

:deep(.ui-header__subheader) {
  margin: 0 auto 7.2rem;
}

.press-office {
  &__button {
    margin: 0 auto;
  }

  :deep(.ui-header) {
    margin-bottom: 1.6rem;
  }
}

@include atM {
  :deep(.top__text) {
    max-width: 65%;
  }

  :deep(.ui-header__subheader) {
    max-width: 80%;
  }

  .press-office {
    :deep(.ui-header) {
      margin-bottom: 4.8rem;
    }
  }
}
</style>
